module.exports = __webpack_public_path__ + "img/bannerDeskHospedagens.31c9f92c.jpg";